/* eslint-disable no-console */
import { useEffect, useRef } from 'react';
import createFonemaCallEvent from '../utils/fonemaCallEventService';

/**
 * Hook específico para manejar el evento onNotAnswer del SDK de Fonema.
 *
 * Se dispara cuando la llamada no es contestada o falla por alguna razón.
 * - Limpia referencias globales si corresponde.
 * - Ejecuta el callback de cierre de UI.
 */
const useFonemaOnNotAnswer = ({ callInfoData, onClose }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const callInfoDataRef = useRef(callInfoData);
  callInfoDataRef.current = callInfoData;

  useEffect(() => {
    let unsubscribeNotAnswer;

    if (window.FonemaWhatsappAudio?.onNotAnswer) {
      console.log('Subscribing to onNotAnswer event (useFonemaOnNotAnswer)');
      unsubscribeNotAnswer = window.FonemaWhatsappAudio.onNotAnswer((event) => {
        console.log('Call not answered / failed with reason:', event);
        createFonemaCallEvent({
          callData: callInfoDataRef.current,
          customerId: callInfoDataRef.current?.customer?.id,
          endedReason: event,
          status: 'failed'
        });

        if (typeof window.clearFonemaCallReferences === 'function') {
          window.clearFonemaCallReferences();
        }

        if (typeof onCloseRef.current === 'function') {
          onCloseRef.current();
        }
      });
    }

    return () => {
      console.log('Cleaning up onNotAnswer listener in useFonemaOnNotAnswer');
      if (unsubscribeNotAnswer && typeof unsubscribeNotAnswer === 'function') {
        console.log('Unsubscribing from onNotAnswer event');
        unsubscribeNotAnswer();
      }
    };
  }, [onCloseRef]);
};

export default useFonemaOnNotAnswer;
